// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SFp7","toggleWrap":"styles_toggleWrap__1bpk2","content":"styles_content__3jypX","selectAreaCode":"styles_selectAreaCode__1HAV2"};